<p-columnFilter [field]=field display="menu" #filterId [showAddButton]="false"
    [showOperator]="false" [showClearButton]="false" [showApplyButton]="false" [showMatchModes]="false" (click)="filterOpen(filterFormGroup, field, 'matchModeControl', 'valueControl');" (onClose)="test()">
    <ng-template pTemplate="filter" let-value let-filter="filterCallback">
        <form [formGroup]="filterFormGroup"
            (keydown.enter)="apply(filterFormGroup, field);filterId.hide()">
            <div formArrayName="customquery">
                <div *ngFor="let searchquery of filterFormGroup.get('customquery')['controls']; let i=index">
                    <div [formGroupName]="i">
                        <p-dropdown [options]="matchModeOptions" (onChange)="showAddRuleBtn()" [formControl]="searchquery.controls['matchModeControl']"
                            optionLabel="label" optionValue="value"></p-dropdown>
                        <p-calendar inputId="navigators" [monthNavigator]="true" [yearNavigator]="true"  yearRange="2000:2030" [formControl]="searchquery.controls['valueControl']"
                            (onSelect)="applyBtn.focus()" (onClose)="applyBtn.focus()"></p-calendar>
                    </div>
                    <button pButton pRipple type="button" label="Add Rule" class="p-button-text mt-2 mb-2" icon="pi pi-plus"
                        *ngIf="showAddRuleButton && filterFormGroup.get('customquery')['controls'].length == 1"
                        (click)="addCustomQuery()"></button>
                    <button pButton pRipple type="button" label="Remove Rule" class="p-button-text p-button-danger mt-2 mb-2" icon="pi pi-trash"
                        *ngIf="filterFormGroup.get('customquery')['controls'].length == 2"
                        (click)="removeCustomQuery(i);applyBtn.focus()"></button>
                    <br />
                </div>
                <div class="d-flex justify-content-around mt-1">
                    <button type="button" class="btn btn-danger btn-sm column-filter-btn" pRipple
                        (click)="clear(field);filterId.hide();initialSetup()">Clear</button>
                    <button type="button" class="btn btn-success btn-sm column-filter-btn" pRipple #applyBtn
                        (click)="apply(filterFormGroup, field);filterId.hide()" [disabled]="!filterFormGroup.valid">Apply</button>
                </div>
            </div>
        </form>
    </ng-template>
</p-columnFilter>